import { normalizeCoupon } from './cartCouponUtils';

/**
 * @typedef {import('./cartCouponUtils').NormalizedCoupon} NormalizedCoupon
 */

export const CART_COUPON_STORAGE_KEY = 'digirasa_cart_coupon';

/**
 * @returns {NormalizedCoupon | null}
 */
export function readStoredAppliedCoupon() {
  try {
    const raw = sessionStorage.getItem(CART_COUPON_STORAGE_KEY);
    if (!raw) return null;
    return normalizeCoupon(JSON.parse(raw));
  } catch {
    return null;
  }
}

/**
 * @param {unknown} coupon
 */
export function persistAppliedCoupon(coupon) {
  const normalized = normalizeCoupon(coupon);
  if (!normalized) {
    clearStoredAppliedCoupon();
    return;
  }
  try {
    sessionStorage.setItem(CART_COUPON_STORAGE_KEY, JSON.stringify(normalized));
  } catch {
    /* quota / private mode */
  }
}

export function clearStoredAppliedCoupon() {
  try {
    sessionStorage.removeItem(CART_COUPON_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Cart passes `appliedCoupon` in navigation state on every hand-off, so its
 * presence (even as null) is authoritative and a removal must not be undone.
 * Back-navigation from payment carries no such state, so fall back to storage.
 *
 * @param {unknown} locationState — react-router location.state
 * @returns {NormalizedCoupon | null}
 */
export function resolveAppliedCoupon(locationState) {
  if (locationState && typeof locationState === 'object' && 'appliedCoupon' in locationState) {
    return normalizeCoupon(/** @type {{ appliedCoupon: unknown }} */ (locationState).appliedCoupon);
  }
  return readStoredAppliedCoupon();
}
